import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.MANAGEMENT,
    loadComponent: () =>
      import('./management.component').then((m) => m.ManagementComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.MANAGEMENT,
    loadComponent: () =>
      import('./management.component').then((m) => m.ManagementComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagementModule {}
